// extracted by mini-css-extract-plugin
module.exports = {"premiumBadge":"PremiumBadge__premiumBadge__HwuDV"};